import React from "react";
import { Link } from "react-router-dom";
import Buttoon from "../../buttoon";
import macc from "../../../assets/images/home/macbok.webp";

const Hero = () => {
  return (
    <>
      <div name = "hero" className="heroSection ">
        <div className="topGradLayer"></div>
        <div className="container">
          <div className="inner v-center h-center flex-column">
            <h1 style={{ fontSize: "53px" }} className="fw-bold text-center">
            The World’s first AI Compliance Assistant
            </h1>
            <h6 className="text-center fs-5 ">
            Trained only on data from
            regulators, reputable advisory bodies and industry standards
            </h6>
            <Link to="/signup">
              <Buttoon
                className="btn btn-primary heroBtn"
                minWidth={210}
                minHeight={43}
                text="Get Started For Free"
              ></Buttoon>
            </Link>
            <img className="macbook" src={macc} alt="MacBook displaying the platform" />
          </div>
        </div>
      </div>
    </>
  );
};

export default Hero;
